import React from "react";
import { Button, Group, Select } from "@mantine/core";

import {
  Subtree,
  SubtreeBody,
  SubtreeHeader,
} from "@piqnt/runtime-core/react/Subtree";
import { useMiddleware } from "@piqnt/runtime-core/react/ReactMount";
import { DraftIcon } from "@piqnt/runtime-core/react/Icon";

import { SpaceContext } from "../space";

interface JointCreateProps {
  title?: string;
}

const jointTypes = [
  { type: "distance-joint", name: "Distance" },
  { type: "rope-joint", name: "Rope" },
  { type: "pulley-joint", name: "Pulley" },
  { type: "friction-joint", name: "Friction" },
  { type: "weld-joint", name: "Weld" },
  { type: "motor-joint", name: "Motor" },
  { type: "prismatic-joint", name: "Prismatic" },
  { type: "revolute-joint", name: "Revolute" },
  { type: "wheel-joint", name: "Wheel" },
];

export const JointCreate = (props: JointCreateProps) => {
  const { context, emit } = useMiddleware<SpaceContext>();

  const [jointType, setJointType] = React.useState(null as string);

  const draftJoint = React.useCallback(() => {
    if (!jointType) return;
    emit("joint-create", { joint: { type: jointType } });
  }, [jointType]);

  const editable = context.editable.value;
  if (!editable) return null;

  return (
    <Subtree open>
      <SubtreeHeader>{props.title ?? "createJoint"}</SubtreeHeader>
      <SubtreeBody>
        <Group gap={4}>
          <Select
            placeholder="..."
            onChange={(type) => setJointType(type)}
            data={jointTypes.map((shapeType) => ({
              value: shapeType.type,
              label: shapeType.name,
            }))}
            size="xs"
            w={100}
          />
          <Button
            disabled={!jointType}
            size="xs"
            variant="default"
            onClick={draftJoint}
          >
            <DraftIcon />
          </Button>
        </Group>
      </SubtreeBody>
    </Subtree>
  );
};
